import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faShareNodes } from "@fortawesome/free-solid-svg-icons";
import "./PlayerBreadcrumb.scss";
import { Button, ButtonType } from "components/Button/Button";
import ShareModal from "components/ShareModal/ShareModal"
import { ModalButtons } from 'components/Modal/ModalButtons';
import { useModal } from 'components/Modal/context/ModalContext';

const PlayerBreadcrumb = ({ course, module, submodule, setBreadcrumbHeight }) => {
	const breadcrumbRef = useRef(null);
	const { openModal } = useModal();

	const buildLink = (submoduleId) => {
		return `/player#courseId-${course.Id}-moduleId-${module.Id}-submoduleId-${submodule.Id}`;
	};

	const handleOpenShareModal = ({ shareLink }) => {
		openModal("Share", <ShareModal shareLink={shareLink} contentName={course.Name + " > " + module.Name + " > " + submodule.Name} />, ModalButtons.None);
	};

	useEffect(() => {
		if (breadcrumbRef.current) {
			const height = breadcrumbRef.current.offsetHeight;
			setBreadcrumbHeight(height);
		}
	}, [course, module, submodule, setBreadcrumbHeight]);

	return (
		<div className="player-breadcrumb" ref={breadcrumbRef}>
			<p>
				{course && <Link to={`/course-view#courseId-${course.Id}`}>{course.Name}</Link>}
				{module && <> <FontAwesomeIcon icon={faChevronRight} size='xs' /> <Link to={`/course-view#courseId-${course.Id}-moduleId-${module.Id}`}> {module.Name}</Link></>}
				<span>{submodule && <> <FontAwesomeIcon icon={faChevronRight} size='xs' /> {submodule.Name}</>}</span> 
			</p>
			<Button
				onClick={() => handleOpenShareModal({ shareLink: buildLink() })}
				type={ButtonType.Tertiary}
				text="Share"
				icon={faShareNodes}
			/>
		</div>
	);
};

export default PlayerBreadcrumb;
